import { defineAttrs as t } from "../../utils/typed-attrs.js";
const s = t({
  id: { default: "" },
  class: { default: "embercom-prosemirror-composer-marker" }
}), o = {
  inline: !0,
  group: "inline",
  selectable: !1,
  attrs: s,
  toDOM(e) {
    const r = e.attrs;
    return ["span", { id: r.id, class: r.class }];
  }
};
export {
  o as markerSpec
};
